import {call, CallProps} from "./call";
import {getDecryptedResponse} from "./crypto";

export interface AppFetchResponse {
    data: any;
    status: number;
}

const getToken = () => {
    // TODO: should get from storage
    return localStorage.getItem('token');
    // return 'U2FsdGVkX19QL7vUTW6v7YK7KBumfK9FdIN2xm5AYfU6bqdQaEFneHcFDaVPHFLfOncb8vD4KNhm6u4N21g1POVxcIGY7mqC3STlIcmwJe4%3D';
}

const getAuthenticationHeaders = (extraHeaders = {}) => {
    const token = getToken();
    if(token) {
        return {
            ...extraHeaders,
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + btoa(token),
        };
    } else {
        return {};
    }
}

export const appFetch = async ({ endpoint, method, params = {}, headers = {}, domain = 'vuelve.co', isEncrypted, abortSignal }: CallProps): Promise<AppFetchResponse> => {
    // const authHeaders = getAuthenticationHeaders(headers);
    // console.log("in appFetch 1: ", endpoint, JSON.stringify(authHeaders));
    const response = await call({ endpoint, method, params: { ...params, domain }, headers: getAuthenticationHeaders(headers), abortSignal });
    // console.log("in appFetch 2: ", response);
    if(response) {
        if(isEncrypted) {
            try {
                const responseData = getDecryptedResponse(response.data);
                return {
                    data: responseData,
                    status: response.status,
                }
            } catch(error) {
                return {
                    data: response.data,
                    status: response.status,
                }
            }
        } else {
            return {
                data: response.data,
                status: response.status,
            }
        }
    } else {
        return {
            data: null,
            status: 500,
        }
    }
};